module.exports = __webpack_public_path__ + "media/img/pages/companies/csl-55536531a0015a3023c6017b6c3f1fde.png";